import { useQuery } from "@tanstack/react-query";
import { PermissionsResponse } from "../lusca-search-api/generated-src";
import { PermissionsApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";

const NO_PERMISSIONS: PermissionsResponse = {
  canRedrive: false,
  canDlqRedrive: false,
};

/** The caller's redrive permissions. Everything is denied until loaded and if the call fails. */
export default function usePermissions(): PermissionsResponse {
  const { data } = useQuery<PermissionsResponse>(
    ["permissions"],
    async () => (await PermissionsApiFactory().getPermissions()).data,
    {
      staleTime: 10 * 60 * 1000,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
  return data ?? NO_PERMISSIONS;
}
